<template>
  <div :class="['me-info-block', classes]">
    <template v-if="isColumn && hasActions">
      <div class="flex grow flex-col gap-2">
        <div
          v-if="$slots.icon"
          class="bg-neutral-bright me-info-block__icon--lg shrink-0 rounded p-3"
        >
          <i class="block me-info-block__icon--md">
            <slot name="icon" />
          </i>
        </div>
        <div class="flex grow flex-col">
          <slot name="content">
            <component
              :is="titleAs"
              v-if="title"
              class="mb-0 me-info-block__title--break-all"
              :class="{
                'text-normal': reverseMarkup,
                'text-primary': !reverseMarkup && primary,
                'text-highlight': !reverseMarkup && textSize === $options.static.TEXT_SIZE.SM,
                'text-title': !reverseMarkup && textSize === $options.static.TEXT_SIZE.MD,
                'text-hero': !reverseMarkup && textSize === $options.static.TEXT_SIZE.LG,
              }"
            >
              {{ title }}
            </component>
            <component
              :is="textAs"
              v-if="text"
              class="mb-0 me-info-block__title--break-all"
              :class="{
                'text-normal': !reverseMarkup,
                'text-primary': reverseMarkup && primary,
                'text-highlight': reverseMarkup && textSize === $options.static.TEXT_SIZE.SM,
                'text-title': reverseMarkup && textSize === $options.static.TEXT_SIZE.MD,
                'text-hero': reverseMarkup && textSize === $options.static.TEXT_SIZE.LG,
              }"
            >
              {{ text }}
            </component>
          </slot>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        v-if="$slots.icon"
        class="bg-neutral-bright shrink-0 rounded p-3"
      >
        <i class="block me-info-block__icon--md">
          <slot name="icon" />
        </i>
      </div>
      <div class="flex grow flex-col">
        <slot name="content">
          <component
            :is="titleAs"
            v-if="title"
            class="mb-0"
            :class="{
              'text-normal': reverseMarkup,
              'text-primary': !reverseMarkup && primary,
              'text-highlight': !reverseMarkup && textSize === $options.static.TEXT_SIZE.SM,
              'text-title': !reverseMarkup && textSize === $options.static.TEXT_SIZE.MD,
              'text-hero': !reverseMarkup && textSize === $options.static.TEXT_SIZE.LG,
            }"
          >
            {{ title }}
          </component>
          <component
            :is="textAs"
            v-if="text"
            class="mb-0"
            :class="{
              'text-normal': !reverseMarkup,
              'text-primary': reverseMarkup && primary,
              'text-highlight': reverseMarkup && textSize === $options.static.TEXT_SIZE.SM,
              'text-title': reverseMarkup && textSize === $options.static.TEXT_SIZE.MD,
              'text-hero': reverseMarkup && textSize === $options.static.TEXT_SIZE.LG,
            }"
          >
            {{ text }}
          </component>
        </slot>
      </div>
    </template>
    <div
      v-if="hasActions"
      class="flex shrink-0"
    >
      <slot name="actions" />
    </div>
  </div>
</template>

<script>

const TEXT_SIZE = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
};

const ORIENTATION = {
  ROW: 'row',
  COLUMN: 'column',
};

const VERTICAL_ALGINMENT = {
  TOP: 'top',
  CENTER: 'center',
};

export default {
	props: {
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    orientation: {
      type: String,
      default: ORIENTATION.ROW,
      validator: (value) => Object.values(ORIENTATION).includes(value),
    },
    verticalAlignment: {
      type: String,
      default: VERTICAL_ALGINMENT.TOP,
      validator: (value) => Object.values(VERTICAL_ALGINMENT).includes(value),
    },
    textSize: {
      type: String,
      default: TEXT_SIZE.SM,
      validator: (value) => Object.values(TEXT_SIZE).includes(value),
    },
    titleAs: {
      type: String,
      default: 'h3',
    },
    textAs: {
      type: String,
      default: 'p',
    },
    reverseMarkup: Boolean,
    background: Boolean,
    primary: Boolean,
    border: Boolean,
  },

  computed: {
    isColumn() {
      return this.orientation === ORIENTATION.COLUMN;
    },

    hasActions() {
      return !!(this.$slots.actions && this.$slots.actions.length);
    },

    isAlignTop() {
      return this.verticalAlignment === VERTICAL_ALGINMENT.TOP;
    },

    isAlignCenter() {
      return this.verticalAlignment === VERTICAL_ALGINMENT.CENTER;
    },

		classes() {
      return {
        'items-start': (this.isColumn && !this.hasActions) || (this.isAlignTop && !this.isColumn),
        'flex-col': this.isColumn && !this.hasActions,
        'items-center': this.isAlignCenter || (this.isColumn && this.hasActions),
        'bg-neutral-shine': this.background,
        'border-1 border-neutral-light': this.border,
      }
    },
	},

  static: {
    TEXT_SIZE: TEXT_SIZE,
  },
}
</script>

<style lang="stylus" scoped>
.me-info-block
  display flex
  padding 1rem
  gap 0.5rem
  border-radius 0.25rem

  &__title
    &--break-all
      word-break break-all

  &__icon
    svg
      width 100%
      height 100%

    &--sm
      width 24px
      height 24px

    &--md
      width 40px
      height 40px

    &--lg
      width 56px
      height 56px
</style>
